import { render, staticRenderFns } from "./MoleculeEditionBillingAcademySalesRecord.vue?vue&type=template&id=663f7665"
import script from "./MoleculeEditionBillingAcademySalesRecord.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionBillingAcademySalesRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports